/**
 * Digit formatter prepends zero for numbers that are less than ten
 */
export const formatDigit = (num: number): string => {
    if (num >= 10) {
        return num.toString();
    }

    return `0${num}`;
};
